import { apiRemote } from "@/lib/apiRemote";

const TTL = 60_000;
const mem = new Map();
const inflight = new Map();
const listingsById = new Map();

const keyOf = (url, params) => `${url}?${new URLSearchParams(params || {}).toString()}`;

export function peek(url, params) {
  const k = keyOf(url, params);
  if (mem.has(k)) return mem.get(k).data;
  try {
    const raw = sessionStorage.getItem(`c:${k}`);
    if (raw) {
      const v = JSON.parse(raw);
      mem.set(k, v);
      return v.data;
    }
  } catch {}
  return null;
}

export async function cachedGet(url, params) {
  const k = keyOf(url, params);
  const hit = mem.get(k);
  if (hit && Date.now() - hit.t < TTL) return hit.data;
  if (inflight.has(k)) return inflight.get(k);
  const p = apiRemote
    .get(url, { params })
    .then(({ data }) => {
      const v = { t: Date.now(), data };
      mem.set(k, v);
      try {
        sessionStorage.setItem(`c:${k}`, JSON.stringify(v));
      } catch {}
      return data;
    })
    .finally(() => inflight.delete(k));
  inflight.set(k, p);
  return p;
}

export function rememberListings(items) {
  (items || []).forEach((l) => l?.listing_id && !listingsById.has(l.listing_id) && listingsById.set(l.listing_id, l));
}

export function rememberListing(l) {
  if (l?.listing_id) listingsById.set(l.listing_id, l);
}

export function getCachedListing(id) {
  return listingsById.get(id) || null;
}
